// @flow
import {
    DATE_SELECTED,
    DISABLE_HOLIDAY_MODE,
    EDITING_HOLIDAY_MODE,
    INITIALIZE_STATE,
    INITIATE_HOLIDAYMODE,
    SET_HOLIDAY_MODE,
    TEMPERATURE_CHANGE,
    TIME_CHANGE
} from './constants';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';
import moment from 'moment-timezone';

const bool = Boolean;

const roundMinutesToNext5 = date =>
    date
        .clone()
        .minutes(Math.ceil((date.minutes() + 1) / 5) * 5)
        .seconds(0)
        .milliseconds(0);

const reducers = {
    [EDITING_HOLIDAY_MODE]: handleReduce(state => state.set('editing', true)),
    [DISABLE_HOLIDAY_MODE]: handleReduce(state =>
        // $FlowFixMe
        state
            .set('enabled', false)
            .set('active', false)
            .set('editing', false)
    ),
    [INITIATE_HOLIDAYMODE]: handleReduce(state => {
        return state.set('initialized', false);
    }),
    [INITIALIZE_STATE]: handleReduce((state, { payload }) => {
        const now = moment().valueOf();
        // $FlowFixMe
        const { start, end, enabled } = payload;
        let startTime =
            start ||
            moment()
                .add(5, 'minutes')
                .valueOf();
        let endTime =
            end ||
            moment()
                .add(5, 'minutes')
                .add(7, 'days')
                .valueOf();

        if (!enabled && moment(startTime).isBefore(moment(now))) {
            startTime = moment()
                .add(5, 'minutes')
                .valueOf();
            endTime = moment()
                .add(5, 'minutes')
                .add(7, 'days')
                .valueOf();
        }

        return fromJS({
            ...payload,
            start: startTime,
            end: endTime,
            initialized: true,
            showEnd: true,
            active: enabled && startTime <= now && endTime > now
        });
    }),
    [SET_HOLIDAY_MODE]: handleReduce(state => state.set('initialized', false).set('editing', false)),
    [TIME_CHANGE]: handleReduce((state, { payload }) => {
        const currentSavedDate = moment(state.get(payload.position, moment())).tz(payload.timezone);
        const [hours, mins] = payload.time.split(':');
        const nextDate = currentSavedDate
            .clone()
            .hours(hours)
            .minutes(mins);
        // $FlowFixMe
        return state.set(payload.position, nextDate.valueOf());
    }),
    [TEMPERATURE_CHANGE]: handleReduce((state, { payload }) => state.set('temperature', payload)),
    [DATE_SELECTED]: handleReduce((state, { payload: { timezone, date } }) => {
        const start =
            // $FlowFixMe
            state.get('start') ||
            moment(new Date(date))
                .tz(timezone)
                .valueOf();
        const end =
            // $FlowFixMe
            state.get('end') ||
            moment(new Date(date))
                .tz(timezone)
                .valueOf();
        // $FlowFixMe
        const showEnd = state.get('showEnd', true);

        const momentStart = roundMinutesToNext5(moment(start).tz(timezone));
        const momentEnd = roundMinutesToNext5(moment(end).tz(timezone));
        const newDate = roundMinutesToNext5(moment(new Date(date)).tz(timezone));

        const conditionsMap = new Map([
            [
                true,
                () => {
                    const prevDate = start ? momentEnd : momentStart;
                    const nextDate = newDate.hours(prevDate.hours()).minutes(prevDate.minutes());
                    // $FlowFixMe
                    return state.set(start ? 'end' : 'start', nextDate.valueOf()).set('showEnd', true);
                }
            ],
            [
                bool(start && newDate.isBefore(momentStart)),
                () => {
                    const nextStart = newDate.hours(momentStart.hours()).minutes(momentStart.minutes());

                    const nextEnd = end
                        ? momentStart.hours(momentEnd.hours()).minutes(momentEnd.minutes())
                        : momentStart;

                    // $FlowFixMe
                    return state
                        .set('start', nextStart.valueOf())
                        .set('end', nextEnd.valueOf())
                        .set('showEnd', true);
                }
            ],
            // $FlowFixMe fix for state.set('showEnd', false)
            [bool(start && momentStart.isSame(newDate, 'date')), () => state.set('showEnd', false)],
            [
                bool(start && showEnd),
                () => {
                    const nextStart = newDate.hours(momentStart.hours()).minutes(momentStart.minutes());
                    // $FlowFixMe
                    return state.set('start', nextStart.valueOf()).set('showEnd', false);
                }
            ]
        ]).get(true);

        const nextState = conditionsMap && conditionsMap();
        return nextState;
    })
};

export default handleActions(
    // $FlowFixMe
    reducers,
    // $FlowFixMe
    fromJS({
        initialized: false,
        editing: false
    })
);



// WEBPACK FOOTER //
// ./src/core/state/holiday-mode/index.js